import strings from '../../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.dependency.name.label,
  showOnDisabled: (values) => false,
  validators: []
}

export const form = {
  formKey: "dependencySearch",
  fields: [
    name
  ]
}
